import { SingleAuthorTemplate } from "./single-author";
import { MultipleAuthorTemplate } from "./multi-author";
import { HeroPrioritySingleAuthorTemplate } from "./hero-priority-single-author/hero-priority-single-author";
import { HeroPriorityMultiAuthorTemplate } from "./hero-priority-multi-author/hero-priority-multi-author";
import { HeroOverlaySingleAuthorTemplate } from "./hero-overlay-single-author/hero-overlay-single-author";
import { HeroOverlayMultiAuthorTemplate } from "./hero-overlay-multi-author/hero-overlay-multi-author";

export function getAuthorTemplate(template) {
  switch (template) {
    case "single-author":
      return SingleAuthorTemplate;
    case "multi-author":
      return MultipleAuthorTemplate;
    case "hero-priority-single-author":
      return HeroPrioritySingleAuthorTemplate;
    case "hero-priority-multi-author":
      return HeroPriorityMultiAuthorTemplate;
    case "hero-overlay-single-author":
      return HeroOverlaySingleAuthorTemplate;
    case "hero-overlay-multi-author":
      return HeroOverlayMultiAuthorTemplate;
    default:
      return SingleAuthorTemplate;
  }
}
